<template>
  <b-container fluid>
    <!-- Modal Export Import RH -->
    <b-modal
      v-model="showModal"
      title="Import Data"
      ok-title="Submit"
      :loading="loadingImport"
      @ok="handleImportRh"
    >
      <template #modal-header>
        <h5 class="text-primary">Import Data</h5>
        <i class="fa fa-times cursor-pointer" @click="showModal = false"></i>
      </template>
      <template>
        <div class="flex flex-column align-items-center">
          <b-form-file
            v-model="importFile"
            type="file"
            class="form-control"
            accept=".xlsx, .xls, .csv"
          />
          <small class="text-black">accept: .xlsx, .xls, .csv</small>
        </div>
        <b-button
          v-if="!loadingExportTemplate"
          variant="outline-primary"
          class="mt-3 w-100"
          @click="handleExportTemplateRH"
        >
          <i class="fa fa-download"></i>
          Download Template
        </b-button>
        <b-button v-else variant="outline-primary" class="mt-3 w-100">
          <b-spinner style="width: 18px; height: 18px" class="mr-2"></b-spinner>
          Downloading
        </b-button>
      </template>
    </b-modal>
    <!-- End Modal Export Import RH -->

    <!-- Modal Info Repoonse Import -->
    <b-modal
      v-model="modalResponseImport"
      title="Import Result"
      size="xl"
      hide-footer
    >
      <ImportResultRh :response="dataResponseImport" />
    </b-modal>

    <!-- SIDEBAR -->
    <b-sidebar
      v-model="showCanvas"
      right
      width="80%"
      bg-variant="white"
      title="Add New Running Hours"
      header-class="p-0"
      shadow
      backdrop
    >
      <template #header>
        <div
          class="w-100 p-2 px-3 d-flex justify-content-between align-items-center"
          style="border-bottom: 1px solid; font-size: 18px; font-weight: 600"
        >
          <i class="fa fa-close cursor-pointer" @click="showCanvas = false"></i>
          <p class="m-0">
            {{ selectedData ? 'Update' : 'Create' }} Running Hours
          </p>
        </div>
      </template>
      <template>
        <formRunningHours
          v-if="showCanvas"
          isFormDetail
          :selectedData="selectedData"
          @close="showCanvas = false"
          @refetch="fetchDataRh"
        />
      </template>
    </b-sidebar>

    <!-- SIDEBAR ADJUSTMENT -->
    <custom-sidebar
      v-model="sidebarAdjustment"
      size="xl"
      title="Adjustmnet Running Hours"
    >
      <RhAdjustmnetList />
    </custom-sidebar>

    <iq-card>
      <template #headerTitle>
        <h5 class="card-title text-primary">
          <strong>RUNNING HOURS</strong>
        </h5>
      </template>
      <template #body>
        <b-row>
          <b-col lg="6" class="mb-3 d-flex">
            <div class="d-flex">
              <b-form class="d-flex mb-3" @submit.prevent="fetchDataRh()">
                <b-form-input
                  v-model="rh.params.search"
                  style="width: 220px"
                  type="text"
                  class="mr-2"
                  placeholder="Search Fleet..."
                ></b-form-input>
              </b-form>
              <date-picker
                v-model="date"
                type="month"
                format="MMMM YYYY"
                style="width: 240px"
                @input="fetchDataRh()"
              />
            </div>
          </b-col>
          <b-col lg="6" class="d-flex justify-content-end">
            <b-button
              variant="outline-primary"
              style="height: max-content"
              class="mr-2 d-flex align-items-center"
              @click="handleExport()"
              :disabled="loadingExport"
            >
              <template v-if="!loadingExport">
                <i class="ri-upload-2-line pl-1"></i>
                Export
              </template>
              <template v-else>
                <b-spinner small class="mr-2"></b-spinner>
                Exporting...
              </template>
            </b-button>
            <b-button
              variant="outline-primary"
              class="d-flex align-items-center"
              style="height: max-content"
              @click="showModal = true"
            >
              <i class="ri-download-2-line pl-1"></i>
              Import
            </b-button>
            <b-button
              variant="outline-primary"
              class="mx-2"
              style="height: max-content"
              @click="$router.push('/maintenance/adjustment-running-hours')"
            >
              Adjustment Running Hours
            </b-button>
            <b-button
              variant="primary"
              style="height: max-content"
              @click="
                showCanvas = true
                selectedData = null
              "
            >
              Add Running Hours
            </b-button>
          </b-col>
          <template v-if="!loading">
            <b-col md="12" v-if="rh.data?.length">
              <div class="overflow-auto" style="position: relative">
                <table class="w-100 table-striped table-bordered table-hover">
                  <tr>
                    <!-- <th rowspan="2">Action</th> -->
                    <th rowspan="2" class="text-center column-1">FLEET</th>
                    <th rowspan="2" class="text-enter column-2">LAST MONTH</th>
                    <th rowspan="2" class="column-3">ENGINE NAME</th>
                    <th
                      class="text-center"
                      :colspan="
                        Object.keys(rh.data[0]?.powers[0]?.days)?.length
                      "
                    >
                      {{ moment(date).format('MMMM') }}
                    </th>
                    <th colspan="4" class="text-center">TOTAL RUNNING HOURS</th>
                  </tr>
                  <tr>
                    <th
                      class="text-center"
                      v-for="(value, key, index) in rh.data[0].powers[0].days"
                      :key="key"
                    >
                      {{ key }}
                    </th>
                    <th class="text-center" style="min-width: 180px">
                      ADJUSTMENT
                    </th>
                    <th class="text-center" style="min-width: 180px">
                      THIS MONTH
                    </th>
                    <th class="text-center" style="min-width: 180px">
                      SINCE GOH
                    </th>
                    <th class="text-center" style="min-width: 180px">
                      ALL TIME
                    </th>
                  </tr>
                  <tbody>
                    <template v-for="(item, i) in rh.data">
                      <tr
                        v-for="(subItem, j) in item?.powers"
                        :key="`${i}-${j}`"
                      >
                        <td
                          align="center"
                          class="bg-white column-1 border-yellow"
                          :rowspan="item.powers.length"
                          v-if="j === 0"
                        >
                          <div class="d-flex flex-column justify-center-center">
                            <div
                              class="mb-2 bg-success py-1"
                              style="cursor: default"
                            >
                              {{ item?.vehicle_name }}
                            </div>
                            <div>
                              <b-button
                                :id="`btn-popover-${i}`"
                                variant="outline-primary"
                                size="sm"
                                class="w-100"
                              >
                                Action
                              </b-button>

                              <b-popover
                                :target="`btn-popover-${i}`"
                                triggers="focus"
                                placement="bottom"
                              >
                                <!-- <b-button
                                  variant="outline"
                                  size="sm"
                                  @click="
                                    () => {
                                      selectedData = item
                                      showCanvas = true
                                    }
                                  "
                                  >Edit Running Hours</b-button
                                > -->
                                <b-button
                                  variant="outline"
                                  size="sm"
                                  @click="handleDelete(item)"
                                >
                                  Reset Running Hours
                                </b-button>
                              </b-popover>
                            </div>
                          </div>
                        </td>

                        <td
                          class="text-center column-2 bg-white"
                          :class="
                            item?.powers?.length == j + 1 ? 'border-yellow' : ''
                          "
                        >
                          {{ subItem?.lastMonth }}
                        </td>
                        <td
                          class="column-3 bg-white border-none"
                          :class="
                            item?.powers?.length == j + 1 ? 'border-yellow' : ''
                          "
                        >
                          <div class="m-0 p-0">
                            <strong>{{ subItem?.power_type ?? '-' }}</strong>
                          </div>
                          <small class="m-0 p-0">
                            {{ subItem?.power_series ?? '-' }}
                          </small>
                        </td>
                        <td
                          v-for="(value, day) in subItem?.days"
                          :key="day"
                          style="min-width: 60px"
                          :class="
                            item?.powers?.length == j + 1 ? 'border-yellow' : ''
                          "
                        >
                          <input
                            class="input-update-rh"
                            type="number"
                            style="max-width: 60px"
                            :value="value"
                            @focus="cellValue = value"
                            @blur="
                              (e) =>
                                handleBlurUpdate(
                                  e,
                                  subItem,
                                  day,
                                  item.vehicle_id
                                )
                            "
                          />
                        </td>
                        <td
                          class="text-center text-primary"
                          :class="
                            item?.powers?.length == j + 1 ? 'border-yellow' : ''
                          "
                        >
                          <span
                            class="cursor-pointer"
                            @click="sidebarAdjustment = true"
                          >
                            {{ formatNumber(subItem?.totalAdjustment) }}
                          </span>
                        </td>
                        <td
                          class="text-center"
                          :class="
                            item?.powers?.length == j + 1 ? 'border-yellow' : ''
                          "
                        >
                          {{ formatNumber(subItem.thisMonth) }}
                        </td>
                        <td
                          class="text-center"
                          :class="
                            item?.powers?.length == j + 1 ? 'border-yellow' : ''
                          "
                        >
                          {{ formatNumber(subItem?.sinceGOH?.running_hours) }}
                        </td>
                        <td
                          class="text-center"
                          :class="
                            item?.powers?.length == j + 1 ? 'border-yellow' : ''
                          "
                        >
                          {{ formatNumber(subItem?.totalRunningHour) }}
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
              <div
                class="mt-4 d-flex align-items-center w-100 justify-content-between"
              >
                <p class="mb-0">
                  Total Rows:
                  <strong class="text-black">{{ rh.params.total }}</strong>
                </p>
                <div class="d-flex justify-content-end">
                  <b-pagination
                    class="mb-0 mr-3"
                    @change="
                      (page) => {
                        rh.params.page = page
                        fetchDataRh()
                      }
                    "
                    v-model="rh.params.page"
                    :total-rows="rh.params.total"
                    :per-page="rh.params.limit"
                    first-number
                    align="center"
                  ></b-pagination>
                  <b-form-select
                    plain
                    v-model="rh.params.limit"
                    :options="limitOptions"
                    style="width: 140px"
                    @input="fetchDataRh"
                  ></b-form-select>
                </div>
              </div>
            </b-col>
          </template>
          <template v-else>
            <div
              class="w-100 d-flex justify-content-center align-items-center my-5 py-5"
            >
              <b-spinner></b-spinner>
            </div>
          </template>
          <template v-if="!rh.data?.length && !loading">
            <b-col cols="12">No Data Here!</b-col>
          </template>
        </b-row>
      </template>
    </iq-card>
  </b-container>
</template>
<script>
import {
  fleetsActions,
  maintenanceActions,
  pmsActions,
} from '@/src/Utils/helper'
import FormRunningHours from './FormRunningHours.vue'
import moment from '@/node_modules/moment/moment'
import { limitOptions } from '@/src/core/mock/data/optionsData'
import { numberFormat } from '@/src/plugins/helpers'
import _ from 'lodash'
import CustomSidebar from '@/src/components/global/CustomSidebar.vue'
import RhAdjustmnetList from '../Components/RhAdjustmnetList.vue'
import ImportResultRh from './ImportResultRh.vue'

export default {
  components: {
    FormRunningHours,
    CustomSidebar,
    RhAdjustmnetList,
    ImportResultRh,
  },
  name: 'MainPageRunningHourNewDetail',
  data() {
    return {
      loading: false,
      selectedData: null,
      showModalFilter: false,
      modalResponseImport: false,
      dataResponseImport: null,
      showCanvas: false,
      runningHours: null,
      limitOptions: limitOptions,
      date: moment(this.$route.query.date).toDate(),
      cellValue: null,
      showModal: false,
      loadingImport: false,
      loadingExport: false,
      loadingExportTemplate: false,
      importFile: null,
      sidebarAdjustment: false,
      rh: {
        params: {
          search: this.$route.query.search || '',
          year: moment().format('YYYY'),
          month: moment().format('MM'),
          page: 1,
          limit: 10,
          totalPages: 1,
          total: 1,
        },
        data: [],
        detailData: null,
      },
    }
  },
  methods: {
    ...fleetsActions,
    ...maintenanceActions,
    ...pmsActions,
    formatNumber(number) {
      return numberFormat(number)
    },
    updateDayInDate(newDay) {
      const date = moment(this.date)
      if (!date.isValid()) {
        console.error('Tanggal tidak valid')
        return null
      }
      date.date(newDay)
      return date.format('YYYY-MM-DD')
    },
    async handleBlurUpdate(e, subItem, day, vehicleId) {
      const { value } = e.target
      if (this.cellValue == value) return false
      const validatedValue = value > 24 ? 24 : value
      try {
        const data = [
          {
            vehicle_power_id: subItem.vehicle_power_id,
            log_date: this.updateDayInDate(day),
            running_hours_day: validatedValue,
            running_minutes: validatedValue * 60,
            power_type_id: subItem?.power_type_id,
            remark: '',
          },
        ]
        const res = await this.updateRunningHoursV3({ data, vehicleId })
        if (res.status == 'success') {
          this.$bvToast.toast('Success Update Data!', {
            title: 'Success',
            variant: 'success',
            solid: true,
            toaster: 'b-toaster-top-right',
            autoHideDelay: 3000,
          })
          this.fetchDataRh(false)
        } else {
          this.$bvToast.toast('Failed Update Data.', {
            title: 'Error',
            variant: 'danger',
            solid: true,
            toaster: 'b-toaster-top-right',
            autoHideDelay: 3000,
          })
          this.fetchDataRh(false)
        }
      } catch (error) {
        this.$bvToast.toast('Terjadi kesalahan server.', {
          title: 'Error',
          variant: 'danger',
          solid: true,
          toaster: 'b-toaster-top-right',
          autoHideDelay: 3000,
        })
        this.fetchDataRh(false)
      }
    },
    async handleExportTemplateRH() {
      try {
        this.loadingExportTemplate = true
        const params = {
          date: moment(this.date).format('YYYY-MM-DD')
        }
        const res = await this.exportTemplateRunningHoursV3(params)
        saveAs(res.data, 'template_running_hours.xlsx')
        this.$swal({
          title: 'Download Template Success',
          text: res.message,
          icon: 'success',
        })
      } catch (error) {
        console.log(error)
        this.$swal({
          title: 'Failed Data Success',
          icon: 'error',
        })
      } finally {
        this.loadingExportTemplate = false
      }
    },
    async handleExport() {
      try {
        this.loadingExport = true
        const year = moment(this.date).format('YYYY')
        const month = moment(this.date).format('MM')
        const params = {
          year,
          month,
        }
        const res = await this.exportRunningHoursV3(params)
        saveAs(res.data, `running_hours_${month}_${year}.xlsx`)
        this.$swal({
          title: 'Export Success',
          text: res.message,
          icon: 'success',
        })
      } catch (error) {
        console.log(error)
        this.$swal({
          title: 'Failed Export Data',
          icon: 'error',
        })
      } finally {
        this.loadingExport = false
      }
    },
    async handleImportRh() {
      try {
        this.loadingImport = this.msgErrImport = []
        const formData = new FormData()
        formData.append('file', this.importFile)
        const res = await this.importRunningHoursV3(formData)
        console.log(res)
        this.dataResponseImport = res.data.data
        this.modalResponseImport = true
        // this.$swal({
        //   title: 'Import Data Success',
        //   icon: 'success',
        // })
      } catch (error) {
        this.$swal({
          title: 'Failed Import Data!',
          type: 'error',
          text: 'Failed Import Data please check your file import!',
          icon: 'error',
          // didClose: () => {
          //   this.showErrImport = true
          // },
        })
      } finally {
        this.loadingImport = false
        this.fetchDataRh()
      }
    },
    formatDate(date) {
      return date ? moment(date, 'DD-MM-YYYY').format('DD MMM YYYY') : '-'
    },
    async fetchDataRh(loadValue = true) {
      this.loading = loadValue
      const params = {
        ...this.rh.params,
        year: moment(this.date).format('YYYY'),
        month: moment(this.date).format('MM'),
      }
      const res = await this.getRunningHoursV3(params)
      if (res?.status === 'success') {
        const { data } = res
        console.log({ data })

        this.rh.data = data.data
        this.rh.params = {
          ...this.rh.params,
          ...data.pagination,
        }
      } else {
        console.log(res)
      }
      this.loading = false
    },
    handleDelete(item) {
      this.$swal({
        title: 'Are You Reset Running Hours?',
        text: `It this action running action run your data Running Hours will permanently delete on your system and start from null.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Reset',
      }).then(async (result) => {
        if (result.isConfirmed) {
          let res = await this.deleteRunningHoursV3({
            id: item.vehicle_id,
            data: {
              year: moment(this.date).format('YYYY'),
              month: moment(this.date).format('MM'),
            },
          })
          if (res.status !== 'success') {
            this.$swal(
              'Error',
              res.data.message ??
                'Something wrong with the server. Cannot get user data.',
              'error'
            )
          } else {
            this.fetchDataRh()
            this.$swal(`Successfully Reset!`, 'success')
          }
        }
      })
    },
  },
  watch: {
    'rh.params.search': _.debounce(function (newVal) {
      this.fetchDataRh()
    }, 500),
  },
  mounted() {
    this.fetchDataRh()
  },
}
</script>

<style scoped>
table th {
  padding: 8px 12px;
}
table td {
  padding: 8px 12px;
  color: black;
}
.column-1 {
  position: sticky;
  left: 0;
  min-width: 180px !important;
}
.column-2 {
  position: sticky;
  left: 180px;
  min-width: 120px !important;
}
.column-3 {
  position: sticky;
  left: 300px;
  min-width: 300px !important;
}
.input-update-rh {
  border: none;
  background: none;
  text-align: center;
  cursor: pointer;
}
.input-update-rh:focus {
  border: 1px solid gray;
  background: white;
  cursor: cell;
}
.border-yellow {
  border-bottom: 2px solid #ffa500 !important;
}
</style>
